import type { UseCoreResult } from './types'
import type { Store } from 'vuex'
import type { Router } from 'vue-router'

export type { UseCoreResult, CoreStoreState } from './types'
export { getCoreStoreState } from './types'

type CreateCoreOptions = {
  store: Store<unknown>
  router: Router
  i18n: unknown
}

type VueI18nBridge = {
  global: {
    t: (...args: [string, ...unknown[]]) => string
    tc: (...args: [string, ...unknown[]]) => string
    tm: (...args: [string, ...unknown[]]) => unknown
  }
}

let core: UseCoreResult | null = null

export function createCore ({ store, router, i18n }: CreateCoreOptions): UseCoreResult {
  if (core && !process.env.JEST_WORKER_ID) {
    throw new Error('createCore has already been called')
  }

  const _i18n = i18n as unknown as VueI18nBridge

  const t = (...args: [string, ...unknown[]]): string => {
    if (args.length > 1) {
      return _i18n.global.tc(...args)
    }
    return _i18n.global.t(...args)
  }

  const tc = (...args: [string, ...unknown[]]): string => {
    return _i18n.global.tc(...args)
  }

  const tm = (...args: [string, ...unknown[]]): unknown => {
    return _i18n.global.tm(...args)
  }

  const apiCall = (...args: unknown[]): Promise<unknown> => {
    const firstArg = args[0] as { url: string }
    if (firstArg.url.match(/^\/loyalty-card-service\//)) {
      return store.dispatch('api/callLoyalty', ...args)
    } else if (firstArg.url.match(/^\/hint-and-walkthrough\//)) {
      return store.dispatch('api/callHintAndWalkthrough', ...args)
    } else {
      return store.dispatch('api/call', ...args)
    }
  }

  core = {
    store,
    router,
    i18n,
    t,
    tc,
    tm,
    apiCall,
  }

  return core
}

export function useCore (): UseCoreResult {
  if (!core) {
    throw new Error('useCore called before createCore')
  }

  return core
}
